import React, { useState, useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import clsx from "clsx";
import {
  CircularProgress,
  FormControlLabel,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Checkbox,
  Avatar,
  FormGroup,
} from "@material-ui/core";
import CloseIcon from '@material-ui/icons/Close';
import store from "redux/Store";
import { AuthSrc } from "util/AuthSrc";
import Confirm from "util/Confirm";

export default function AddTracksToEpisodes({
  classes,
  onClose,
  open,
  track,
  cf,
  props
}) {

  const {
    orgRuntime: {
      runtime: {
        _trackFields: _trackFields,
        _trackMusicOrigins: trackOrigins
      }
    },
    clearanceRuntime: { runtime: cfRuntime }
  } = store.getState();

  const { 
    data: { 
      posting: { busy }, 
      episodeList,
      closeOnRefresh, 
      refreshBlockingPopup
    }, 
    getCFTrackEpisodes, 
    openWizard,  
    closePopupOnRefresh,
    setBlockRefresh, 
  } = props;

  const [cfEpisodeList, setCfEpisodeList] = useState([]);
  const [initCfEpisodeList, setinitCfEpisodeList] = useState([]);
  const [artworkProps, setArtworkProps] = useState({ title: "", alt: "", variant: "square", src: "", });
  const [errorSaving, setErrorSaving] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectAll, setSelectAll] = useState(false);
  const [selectionLimitData, setSelectionLimitData] = useState(null);
  const [episodeLimitWarning, setEpisodeLimitWarning] = useState(false);
  const [episodeLimitWarningHybrid, setEpisodeLimitWarningHybrid] = useState(false);
  const [episodeLimitWarningText, setEpisodeLimitWarningText] = useState("");
  const [statusRefer, setStatusRefer] = useState(false);
  const [canSave, setCanSave] = useState(false);
  const [openCFWizard, setOpenCFWizard] = useState(false);

  useEffect(() => {
    setLoading(true);
    if (track) {
      setArtworkProps({
        title: track[_trackFields.trackTitle.id],
        alt: `Art work for ${track[_trackFields.trackTitle.id]}`,
        variant: "square",
        src: track[_trackFields.prodArtworkUrl.id],
      });
    }
    setCfEpisodeList(episodeList.map(d => {
      return {
        ...d,
        selected: false
      }
    }))
    getCFTrackEpisodes({
      masterFormId: cf.master ? cf.id : cf.selectedMasterFormId,
      trackId: track.trackDetails.id
    }, (data, error) => {
      if (data && data.length > 0) {
        let selectedEpList = episodeList.map(d => {
          return {
            ...d,
            selected: data.map(d => d.clearanceFormId).indexOf(d.id) !== -1 ? true : false
          }
        }) || [];

        setCfEpisodeList(selectedEpList);
        setinitCfEpisodeList(selectedEpList);
      }
      setLoading(false);
    });

    let selectionLimits = cfRuntime._config.CF_ADD_EPISODE_LIMITS.find(epl => epl.type === cf.clearanceFormType);
    if (cfRuntime?._config?.CF_ADD_EPISODE_LIMITS?.length
      && cf.clearanceFormType
      && track.origin
      && cfRuntime._config.CF_ADD_EPISODE_LIMITS.find(epl => epl.type === cf.clearanceFormType)
    ) {
      setSelectionLimitData(selectionLimits);
    }
    if (setBlockRefresh) setBlockRefresh(true);
    return () => {
      if (setBlockRefresh && refreshBlockingPopup) setBlockRefresh();
    }
  }, []);

  useEffect(() => {
    // this is to wait until state updates are done in handleSaveTrackEpisodes
    if (canSave) {
      handleSave(openCFWizard);
    }
  }, [canSave])

  useEffect(() => {
    if (cfEpisodeList.length > 0 && cfEpisodeList.filter(e => e.selected)?.length > 0 && cfEpisodeList.length === cfEpisodeList.filter(e => e.selected)?.length) {
      setSelectAll(true);
    }
  }, [cfEpisodeList])

  const handleChange = (event) => {
    let masterId = cf.master ? cf.id : cf.selectedMasterFormId;

    if (event.target.name === masterId && event.target.checked) {
      setCfEpisodeList(cfEpisodeList.map(d => {
        return {
          ...d,
          selected: (d.id === masterId) ? event.target.checked : false
        }
      }));
    } else {
      setCfEpisodeList(cfEpisodeList.map(d => {
        return {
          ...d,
          selected: (event.target.name === "allEpisodes")
            ? (d.id === masterId)
              ? false
              : event.target.checked
            : (d.id === event.target.name)
              ? event.target.checked
              : (d.id === masterId)
                ? false
                : d.selected
        }
      }));
    }


    if (event.target.name !== "allEpisodes") {
      setSelectAll(false);
    }

  };


  const handleSaveTrackEpisodes = (openCfWizard = false) => {

    if (selectionLimitData) {

      let selectedList = cfEpisodeList?.filter(obj => obj.selected) || [];
      const initSelectedList = initCfEpisodeList.filter(ep => ep.selected) || [];

      if (
        selectionLimitData
        && selectedList.length > selectionLimitData.limit
        && selectionLimitData.origins?.includes(track.origin)
        && (track.trackUsage || track.usage)
        && selectionLimitData.usages?.some(u => (u.value === track.trackUsage || u.value === track.usage))
        && track.clearancestatus 
        && (+track.clearancestatus ===  cfRuntime?._config?.CF_TRACK_ORG_STATUS?.APPROVED || +track.clearancestatus ===  cfRuntime?._config?.CF_TRACK_ORG_STATUS?.MIG_CLEARED)
      ) {

        let usageType = selectionLimitData.usages.find(u => u.value === track.trackUsage || u.value === track.usage)?.type ?? 'background';
        let dialogText = `You are about to add this to more than ${selectionLimitData.limit} episodes. Please confirm that the usage is the same as the original clearance.`

        if (usageType === 'title') {
          if(+track.clearancestatus ===  cfRuntime?._config?.CF_TRACK_ORG_STATUS?.MIG_CLEARED){
            dialogText = `Adding to more than ${selectionLimitData.limit} episodes is not allowed.`;
            setEpisodeLimitWarningHybrid(true);
          }else{
            setStatusRefer(true);         
            dialogText = `You are about to add to more than ${selectionLimitData.limit} episodes. Please note that the status will reflect a referred result, requiring further advice on licensing commercial music. As the usage indicated is for multiple episodes, this will not automatically qualify to use commercial music under the scope of Sky's blanket licence. Alternatively, SATV music can be used for title music in multiple episodes of a series.`;
          }
        }

        setEpisodeLimitWarningText(dialogText);
        setEpisodeLimitWarning(true);
        return;
      } else {
        setEpisodeLimitWarning(false);
        setStatusRefer(false);
      }

    }

    setOpenCFWizard(openCfWizard);
    setCanSave(true);
    // handleSave();
  }

  const handleSave = () => {
    const {
      refreshCF,
      getCFAddTracksToEpisodes,
      orgRuntime: {
        runtime: {
          _trackFields: trackFields,

        }
      },
      user,
      data: {
        editing,
      },
    } = props;

    setEpisodeLimitWarning(false);
    setErrorSaving(false);
    setCanSave(false);

    let confirmed = [];
    let trackDetails = track.trackDetails;
    let selectionLimits = cfRuntime._config.CF_ADD_EPISODE_LIMITS.find(epl => epl.type === cf.clearanceFormType);

    if (trackDetails) {
      confirmed.push({
        trackDetails: trackDetails,
        origin: trackDetails[trackFields.musicOrigin.id],
        clearancestatus: statusRefer ? (selectionLimits?.cfReferStatus ?? 0) : track.clearancestatus,
        messageid: null,
        by: user.id,
        at: new Date().toISOString(),
        adminOverridden: track.adminOverridden,
        trackNotes: track.trackNotes,
      });
    }

    let selectedEpisodes = cfEpisodeList.filter(ep => ep.selected).map(obj => obj.id) || [];
    let initSelectedEpisodes = initCfEpisodeList.filter(ep => ep.selected).map(obj => obj.id) || [];
    let removedList = initSelectedEpisodes.filter(r => !selectedEpisodes.includes(r)) || [];


    let trackId = trackDetails.id;
    const addToEpisodeData = {
      selectedEpisodes: selectedEpisodes,
      addedList: selectedEpisodes.filter(t => initSelectedEpisodes.indexOf(t) === -1),
      removedList: removedList,
      isMaster: cf.master ? true : false,
      masterFormId: cf.master ? cf.id : cf.selectedMasterFormId,
      clearanceFormId: track.clearanceFormId,
      clearanceFormType: cf.clearanceFormType,
      confirmed: confirmed,
      trackClearance: statusRefer ? null : {
        trackProps: cf?.clearance?.props?.length > 0 ? cf.clearance.props.filter(p => p.trackId === trackId) : [],
        trackCommits: (cf?.clearance?.commits && cf?.clearance?.commits[trackId]) ? cf.clearance.commits[trackId] : null
      },
      tracks: [trackId],
    };

    if(openCFWizard){
      openWizard({ ids: [trackId], ...(selectedEpisodes?.length > 0 ? {addToEpisodeData : addToEpisodeData} : {}) });
    }else{
      let selectedEpisodes = cfEpisodeList.filter(ep => ep.selected).map(obj => obj.id) || [];


      if(selectedEpisodes.length > selectionLimitData.limit
        && selectionLimitData.origins?.includes(track.origin)
        && track.trackUsage
        && selectionLimitData.usages?.some(u => u.value === track.trackUsage)
        && +track.clearancestatus ===  cfRuntime?._config?.CF_TRACK_ORG_STATUS?.APPROVED
      ){

        const {
          clearanceRuntime: { runtime: cfRuntime }
        } = store.getState();

        const { postItem } = props;

        let rulesList = cfRuntime?._rules || [];
        let propsList = cf?.clearance?.props || [];
        let commitList = cf?.clearance?.commits || {};

        let epRule, epCommit, epConfirmed, epTrackNotes;

        epRule = rulesList.find(r => r.collectionId === selectionLimits?.cfReferRuleId);
        propsList = propsList.map(p=>{
          if(p.id === selectionLimits?.episodeParamId && p.trackId === trackId){
            return {
              ...p, 
              v : "Yes"
            }
          }
          return p;
        })

        if(trackId in commitList){
          epCommit = commitList[trackId];
          if(epCommit && epRule){
            epCommit = {
              ...epCommit, 
              rules: [
                {
                  ...epRule.gate[0],
                  withMessage: epRule.withNotes || [],
                  conditionid: epRule.id,
                  ruleid: epRule.collectionId,
                  index: epRule.collectionPos,
                  colName: epRule.colName,
                  unconfirmed: false,
                }
              ]
            }
            commitList[trackId] = epCommit;
          }
        }

        if(epRule){
          epRule = {
            ...epRule,
            withNotes: epRule.withNotes?.filter(r => r) ?? []
          }

          epTrackNotes = epRule.withNotes[0] ? [epRule.withNotes[0]?.message]: [];
        }

        if(confirmed[0]){
          let tempConfirmed = confirmed[0];
          confirmed = [
            {
              ...tempConfirmed,
              clearancestatus: selectionLimits?.cfReferStatus ? `${selectionLimits?.cfReferStatus}`: 0,
              trackNotes: epTrackNotes,
              adminOverridden: 0, 
              adminOverriddenWithNotes: "" 
            }
          ]
        }

        let postParams = {
          cf: {
            ...cf,
            clearance: {
              ...cf.clearance,
              commits: commitList,
              props: propsList
            },
            confirmed: [confirmed[0]]
          },
          changedFields: [],
          changedTrackFields: ["trackNotes", "clearancestatus"],
          changedTrackIds: [trackId],
          episodeList: null,
          resetFormInsideWizard: false
        }

        if(postItem){
          postItem("saveform", null, postParams, (data, error) => {
            if (error) {
              setErrorSaving(true);
            } 
            else if (data) {
              delete postParams.cf["confirmed"];
              onClose(true, postParams.cf);
            }
          }, true);
        }



      }
      else{
        getCFAddTracksToEpisodes(addToEpisodeData, (data, error) => {
          if (error) {
            setErrorSaving(true);
          } else if (data) {
            if (data.removedList.indexOf(editing.id) != -1 || data.addedList.indexOf(editing.id) != -1) {
              refreshCF(editing);
            }
            onClose();
          }
        });
      }

    }
  }

  function groupArray(inputArray) {
    const outputArray = [];

    for (let i = 0; i < inputArray.length; i += 2) {
      if (i + 1 < inputArray.length) {
        outputArray.push([inputArray[i], inputArray[i + 1]]);
      } else {
        outputArray.push([inputArray[i]]);
      }
    }

    return outputArray;
  }

  return (
    <>
      {episodeLimitWarning &&
        <Confirm
          name="addEpisodeConfirmation"
          classes
          isOpen={episodeLimitWarning}
          title={`Add to Episode(s) ${!episodeLimitWarningHybrid ? "Confirm" : "Not Allowed"}`}
          content={episodeLimitWarningText}
          confirm={`${episodeLimitWarningHybrid ? "OK" : "Yes, Continue"}`}
          onConfirm={(e) => {
            if (episodeLimitWarningHybrid) {
              setEpisodeLimitWarningHybrid(false);
              setEpisodeLimitWarning(false);
            } else {
              handleSave();
            }
          }}
          cancel={`${!episodeLimitWarningHybrid ? "No, Cancel" : ""}`}
          onCancel={(e) => {
            setEpisodeLimitWarning(false);
          }}
        />}

      {/* Close the clearance form if realtime update triggered */}
      {closeOnRefresh && open &&
        <Confirm
          name="closeOnRefreshDialogAddToEpisode"
          classes
          isOpen={closeOnRefresh || false}
          title={'Clearance Form Updated'}
          content={'This Clearance Form has been updated. Click OK to see the latest changes.'}
          confirm="OK"
          onConfirm={() => {
            if (setBlockRefresh) setBlockRefresh(false, true);
            if (closePopupOnRefresh) closePopupOnRefresh();
            onClose();
          }}
        />
      }
      <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        className={clsx(classes.dialogWrapper, "episodePopup")}
        maxWidth={"lg"}

      >
        <DialogTitle id="alert-dialog-title">
          <div className="popupConainer">
            <span>
              Add to Episode(s)
            </span>


            {onClose ? (
              <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                <CloseIcon />
              </IconButton>
            ) : null}
          </div>


        </DialogTitle>

        <DialogContent>
          <div className="trackDetails">
            <span>
              <Avatar
                title={artworkProps?.title}
                alt={artworkProps?.alt}
                variant={artworkProps?.variant}
                className={classes.tableArtwork}
                src={AuthSrc(artworkProps?.src)}
              >
                {(artworkProps?.title)?.charAt(0)?.toUpperCase()}
              </Avatar>

            </span>

            <span className="trackTitleDetails">
              {track["trackDetails"][_trackFields.trackTitle.id]}

            </span>

            <span className="trackOriginDetails">
              <span className="trackTitleinSeries"> Origin: </span>
              {Object.values(trackOrigins).find(e => track.origin === e.id)?.label || ""}
            </span>

          </div>
          <FormControlLabel
            className="episodeMainLabel"
            control={
              <Checkbox
                checked={selectAll || false}
                onChange={(e)=>{
                  handleChange(e);
                  setSelectAll(e?.target?.checked)
                }}
                name="allEpisodes"
                color="primary"
                indeterminate={!selectAll && cfEpisodeList.some(e => e.selected)}
              />
            }
            label="Select All Episodes"
          />
          
          <Grid className="listofEpisodes" container key={`CfHqContainer${track[_trackFields.id.id]}`}>
            <FormGroup row key={`cfEpisodeListGroup${track[_trackFields.id.id]}`}>

              {(!loading) && groupArray(cfEpisodeList).map((gitem, index) => {
                return (
                  <div className="groupOfEpisodes" key={`${track[_trackFields.id.id]}gitemdiv${index}`}>
                    {gitem.map((episode, index) => (
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={episode.selected || false}
                            onChange={handleChange}
                            name={episode.id}
                            color="primary"
                            key={`${episode.id}Checkbox`}
                          />
                        }
                        label={episode.episodeTitle || episode.name || ""}
                        key={`${episode.id}FormControlLabel`}
                      />
                    ))}
                  </div>
                )
              }
              )}
              {loading && <CircularProgress />}
            </FormGroup>
          </Grid>
        </DialogContent>
        <DialogActions>
          {errorSaving && <div role="alert" className={clsx(classes.customError, classes.customErrorAlign)}>Error while saving</div>}
          <Button
            disabled={busy || props.data.cfAddTracksToEpisodesLoading || loading || false}
            className={clsx(classes.dialogYesButton, "dialogYesButton")}
            onClick={() => {
              handleSaveTrackEpisodes(+track?.clearancestatus === 0)
            }
            }
            color="primary">
            {+track?.clearancestatus === 0 ? "Clear Me" : "Save"}
            {(busy || props.data.cfAddTracksToEpisodesLoading) && <CircularProgress />}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
